import { ApplicationRef, ComponentFactoryResolver, Injectable, Injector, Type } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

/**
 * DialogService with the app's default motion. Review found 19 dialogService
 * .open call sites OUTSIDE modal.service.ts (task form, invoice dialogs, the
 * account/content list editors); with the mask fade fixed at 350ms, any dialog
 * whose panel still closed at PrimeNG's 150ms default would destroy its mask
 * mid-fade. Provided in app.module as { provide: DialogService, useClass: ... }
 * so every injector - lazy modules included - gets the default centrally. A
 * call site passing its own transitionOptions still wins.
 */
@Injectable()
export class ConductorDialogService extends DialogService {
  constructor(componentFactoryResolver: ComponentFactoryResolver, appRef: ApplicationRef, injector: Injector) {
    super(componentFactoryResolver, appRef, injector);
  }

  public open(componentType: Type<any>, config: DynamicDialogConfig): DynamicDialogRef {
    return super.open(componentType, {
      transitionOptions: '350ms cubic-bezier(0.25, 1, 0.5, 1)',
      ...config,
    });
  }
}
